export function phoneInputMask(value: string) {
  const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/) || '';
  const num = !x[2]
    ? `${x[1].length ? `(${x[1]}` : ''}`
    : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
  return num;
}
